const KEY_CODES = {
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  HOME: 'Home',
  END: 'End',
  ENTER_KEY: 'Enter',
  SPACE_KEY: ' ',
  TAB: 'Tab',
  ESCAPE: 'Escape',
  DELETE: 'Delete',
  BACKSPACE: 'Backspace',
  C: 'c',
  V: 'v',
  PAGE_UP: 'PageUp',
  PAGE_DOWN: 'PageDown',
};

export default KEY_CODES;
